export const baseEnvironment = {
	AZURE_AUTHORITY: "https://login.microsoftonline.com/92484b96-ad23-48aa-b534-e36a56a7eafd",
	slugBackend: "api",
	// NEXT_PUBLIC_GA_MEASUREMENT_ID: "G-R0GBJS75S0",
	// GA_API_SECRET: "Jq-OMXr2QTS0xGgVobwRZA",
};
